export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Workspace basiscomponenten met intelligente features voor moderne arbeidskrachten die werken met SaaS, webapps en filesharing.</p><p>Inclusief SSO met ondersteuning voor meervoudige authenticatie voor alle apps, workspace-intelligentie met microapps, gepersonaliseerde feeds en virtuele assistentie, maar ook Citrix Content Collaboration Standard service met onbeperkte opslag van bestanden.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Complete workspace-oplossing voor mensen die wel een volledige digitale workspace met fijnmazige security nodig hebben, maar geen virtuele apps en desktops.</p><p>Met de functionaliteit van Workspace Standard, plus geavanceerde securitymechanismen voor SaaS en web, Unified Endpoint Management en Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Uitgebreide workspace-oplossing met opties voor hybride implementatie van Citrix Virtual Apps and Desktops.</p><p>Met de functionaliteit van Workspace Premium, plus cloudbeheer voor Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials helpt kleine en middelgrote organisaties bij het beschermen van hun data door middel van een eenvoudiger en veiliger aanmeldproces voor SaaS- en webapplicaties.</p><p>Inclusief Single Sign-On voor SaaS- en webapplicaties, met meervoudige authenticatie voor verdere beveiliging van het aanmeldproces, wat de kans dat een account wordt gehackt, met 99,9% verkleint.</p>"
            },
            terms: "*Per gebruiker, per maand",
            btn1: "Functietabel weergeven"
        },
        features: {
            disclaimer1: "*Gemiddelde adviesprijs in USD per gebruiker voor 500 gebruikers met een 3-jarig abonnement. Werkelijke prijzen kunnen verschillen.<br /> Citrix Workspace licentieopties vanaf 25 gebruikers.",
            disclaimer2: "**Workspace Premium service is zonder Workspace Analytics voor on-premise Citrix Virtual Apps and Desktops implementaties."
        },
        calculator: {
            edition: "Selecteer uw versie",
            title: "Bereken uw prijs",
            users: "Selecteer uw gebruikers",
            estCost: "Uw geschatte maandelijkse kosten",
            btn1: "Praat met een expert",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Licentieopties vanaf 25 gebruikers. Probeer het opnieuw.",
            lowUserMsg: "Minder dan 500 gebruikers? Wij zijn er ook voor minder grote organisaties.",
            volumeDiscount: "Meer dan 2500 gebruikers? Voor u zijn er speciale volumekortingen.",
            contract1: "Contract 1 jaar",
            contract3: "Contract 3 jaar",
            contract3savings: "20% besparing",
            term: "Per gebruiker, per maand",
            disclaimer: "*Deze calculator biedt slechts een raming en mag alleen worden gebruikt voor budgettering. Werkelijke prijzen kunnen verschillen. Informeer bij uw Citrix team of partner naar mogelijke korting."
        },
        stats: {
            title: "Uw voordelen",
            stat1: {
                title: "Betere werknemerservaring",
                desc: "<b>4 van de 5</b> IT-leiders vinden werknemerservaring een cruciaal onderdeel van hun digitale transformatie."
            },
            stat2: {
                title: "Laat medewerkers kiezen",
                desc: "<b>78%</b> van de bedrijfsleiders gaat akkoord met de stelling dat de werknemerservaring verbetert als medewerkers zelf kunnen kiezen welke applicaties en devices ze gebruiken."
            },
            stat3: {
                title: "Eenvoudige toegang",
                desc: "<b>47%</b> van de bedrijfsleiders vindt eenvoudige toegang tot informatie die nodig is voor het werk, het belangrijkste aspect voor het verhogen van de betrokkenheid van werknemers."
            },
            btn1: "Praat met een expert",
            disclaimer: "Bron: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}